import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const SicknessKindList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="sicknessKind"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default SicknessKindList;
